import React from "react";
import { Box } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import { Body } from "../../../components/Typography";

export const OrderEventLogsTab: React.FC = () => {
  return (
    <Box sx={{ padding: tokens.spacing[4] }}>
      <Body>Event Logs</Body>
    </Box>
  );
};
